(() => {
  'use strict';

  const ACTIVE_EXPERIMENT_KEY = 'active_experiment';
  const EXPERIMENT_NAME = 'klarna_position_ab';
  const VARIATION_VALUE = 'variation';
  const REFRESH_ATTEMPTS = 6;
  const REFRESH_INTERVAL_MS = 140;

  const getCartAttributeState = async () => {
    try {
      const res = await fetch(`${window.Shopify.routes.root}cart.js`, {
        headers: { Accept: 'application/json' }
      });
      if (!res.ok) return { activeExperiment: '' };

      const cart = await res.json();
      const attributes = cart.attributes || {};

      return {
        activeExperiment: attributes[ACTIVE_EXPERIMENT_KEY] || ''
      };
    } catch (error) {
      return { activeExperiment: '' };
    }
  };

  const setCartAttributeValue = async (value) => {
    const attributes = {};
    attributes[ACTIVE_EXPERIMENT_KEY] = value === VARIATION_VALUE ? EXPERIMENT_NAME : '';

    const res = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes })
    });

    if (!res.ok) {
      throw new Error(`Failed to update cart attribute: ${res.status}`);
    }
  };

  const findKlarnaBlock = (root) => {
    if (!root) return null;
    const byClass = root.querySelector('.js-klarna-block');
    if (byClass) return byClass;
    const placement = root.querySelector('klarna-placement');
    if (placement) return placement.closest('.block-layout') || placement.parentElement;
    return null;
  };

  const refreshKlarnaWidgets = () => {
    let attempt = 0;

    const run = () => {
      attempt += 1;

      if (window.KlarnaOnsiteService) {
        try {
          window.KlarnaOnsiteService.push({ event: 'refresh-widgets' });
        } catch (e) {}
      }

      window.dispatchEvent(new Event('resize'));

      if (attempt < REFRESH_ATTEMPTS) {
        setTimeout(run, REFRESH_INTERVAL_MS);
      }
    };

    run();
  };

  const enforceFirstLowerPlacement = () => {
    const productInfo = document.querySelector('.product__info-container');
    if (!productInfo) return;

    const lowers = productInfo.querySelectorAll('.product__lower');
    if (lowers.length < 2) return;

    const firstLower = lowers[0];
    const secondLower = lowers[1];
    const ensureExperimentContainer = () => {
      let container = firstLower.querySelector('.product__lower-apps--experiment');
      if (container) return container;

      container = document.createElement('div');
      container.className = 'product__lower-apps product__lower-apps--experiment';
      firstLower.appendChild(container);
      return container;
    };

    if (findKlarnaBlock(firstLower)) {
      refreshKlarnaWidgets();
      return;
    }

    const source = findKlarnaBlock(secondLower) || findKlarnaBlock(productInfo);
    if (!source) return;

    ensureExperimentContainer().appendChild(source);
    refreshKlarnaWidgets();
  };

  const restoreDefaultLowerPlacement = () => {
    const productInfo = document.querySelector('.product__info-container');
    if (!productInfo) return;

    const lowers = productInfo.querySelectorAll('.product__lower');
    if (lowers.length < 2) return;

    const firstLower = lowers[0];
    const secondLower = lowers[1];

    const firstKlarna = findKlarnaBlock(firstLower);
    const secondKlarna = findKlarnaBlock(secondLower);

    if (firstKlarna && !secondKlarna) {
      secondLower.appendChild(firstKlarna);
      refreshKlarnaWidgets();
    }

    const experimentContainer = firstLower.querySelector('.product__lower-apps--experiment');
    if (experimentContainer && experimentContainer.children.length === 0) {
      experimentContainer.remove();
    }
  };

  const applyFlag = async (nextValue) => {
    const state = await getCartAttributeState();
    const expectedActiveExperiment = nextValue === VARIATION_VALUE ? EXPERIMENT_NAME : '';

    if (state.activeExperiment === expectedActiveExperiment) return;

    await setCartAttributeValue(nextValue);
  };

  window.convertKlarnaPosition = {
    activeVariant: null,
    activeExperiment: '',

    shouldKeepKlarnaInFirstLower() {
      return (
        this.activeVariant === 'variant' ||
        this.activeExperiment === EXPERIMENT_NAME
      );
    },

    control() {
      this.activeVariant = 'control';
      this.activeExperiment = '';
      applyFlag('').catch(() => {});
      setTimeout(restoreDefaultLowerPlacement, 80);
    },

    variant() {
      this.activeVariant = 'variant';
      this.activeExperiment = EXPERIMENT_NAME;
      applyFlag(VARIATION_VALUE).catch(() => {});
      setTimeout(enforceFirstLowerPlacement, 120);
    },

    reset() {
      this.activeVariant = null;
      this.activeExperiment = '';
      applyFlag('').catch(() => {});
      setTimeout(restoreDefaultLowerPlacement, 80);
    }
  };

  getCartAttributeState().then((state) => {
    window.convertKlarnaPosition.activeExperiment = state.activeExperiment;

    if (state.activeExperiment === EXPERIMENT_NAME) {
      window.convertKlarnaPosition.activeVariant = 'variant';
      setTimeout(enforceFirstLowerPlacement, 220);
    }
  });

  document.addEventListener('productLowerUpdated', () => {
    if (!window.convertKlarnaPosition.shouldKeepKlarnaInFirstLower()) return;
    setTimeout(enforceFirstLowerPlacement, 160);
    setTimeout(enforceFirstLowerPlacement, 380);
  });

  document.addEventListener('productLowerKlarnaRestored', () => {
    if (!window.convertKlarnaPosition.shouldKeepKlarnaInFirstLower()) return;
    setTimeout(refreshKlarnaWidgets, 120);
  });
})();
